import {Injectable} from '@angular/core';
import {NewsEntitiesEffects} from '../../../../store/effects/news-entities.effects';
import {NewsArticleActions} from './news-article.actions';


@Injectable()
export class NewsArticleEffects {

  constructor(
    private _newsEntitiesEffects: NewsEntitiesEffects,
  ) {
  }

  readonly readNews$ = this._newsEntitiesEffects.readNews$(
    NewsArticleActions.readLatestNews,
    NewsArticleActions.readLatestNewsSuccess,
    NewsArticleActions.readLatestNewsFailure,
  );

}
